var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import InfinitySvg from './infinity.icon.svg';
export const InfinityIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, fillOpacity: 1, SvgComponent: InfinitySvg }));
_react_refresh_temp_1 = InfinityIcon;
$RefreshReg$(_react_refresh_temp_1, "InfinityIcon");
